import type { CertificateSettings } from '../types';

export const DEFAULT_CERTIFICATE_SETTINGS: CertificateSettings = {
  titleText: 'Certificate of Achievement',
  textColor: '#1e293b', // Slate 900
  font: 'System Default',
  backgroundColor: '#ffffff',
  accentColor: '#0f172a', // Slate 950
  secondaryColor: '#64748b', // Slate 500
  showOnResults: true
};

// Font options available in the certificate editor
export const SYSTEM_FONTS = {
  'System Default': '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, system-ui, sans-serif',
  'System UI': 'system-ui, sans-serif',
  'SF Pro': '-apple-system, BlinkMacSystemFont, sans-serif',
  'Segoe UI': '"Segoe UI", sans-serif',
  'Inter': 'Inter, system-ui, sans-serif'
} as const;